module.exports = __webpack_public_path__ + "static/media/abig.c5dabe9a.png";